// /* ===========================
//    WISHLIST FUNCTIONALITY
//    Shopify Custom Wishlist
//    =========================== */

// (function() {
//   'use strict';

//   const STORAGE_KEY = 'shopify_wishlist';
//   const TOAST_DURATION = 2500;

//   // ============ STATE MANAGEMENT ============
//   const WishlistStore = {
//     get() {
//       try {
//         const data = localStorage.getItem(STORAGE_KEY);
//         return data ? JSON.parse(data) : [];
//       } catch (e) {
//         console.error('Wishlist storage error:', e);
//         return [];
//       }
//     },

//     set(items) {
//       try {
//         localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
//         this.dispatchUpdate();
//       } catch (e) {
//         console.error('Wishlist save error:', e);
//       }
//     },

//     add(product) {
//       const items = this.get();
//       if (!items.find(item => item.id === product.id)) {
//         items.push({
//           ...product,
//           addedAt: Date.now()
//         });
//         this.set(items);
//         return true;
//       }
//       return false;
//     },

//     remove(productId) {
//       const items = this.get().filter(item => String(item.id) !== String(productId));
//       this.set(items);
//     },

//     removeByHandle(handle) {
//       const items = this.get().filter(item => item.handle !== handle);
//       this.set(items);
//     },

//     clear() {
//       this.set([]);
//     },

//     has(productId) {
//       return this.get().some(item => String(item.id) === String(productId));
//     },

//     count() {
//       return this.get().length;
//     },

//     dispatchUpdate() {
//       document.dispatchEvent(new CustomEvent('wishlist:updated', {
//         detail: { items: this.get(), count: this.count() }
//       }));
//     }
//   };

//   // ============ UI HELPERS ============
//   function showToast(message, isError = false) {
//     const toast = document.querySelector('[data-wishlist-toast]');
//     if (!toast) return;
    
//     const textEl = toast.querySelector('[data-wishlist-toast-text]');
//     if (textEl) textEl.textContent = message;
    
//     toast.classList.toggle('is-error', isError);
//     toast.classList.add('is-visible');
    
//     clearTimeout(toast._timeout);
//     toast._timeout = setTimeout(() => {
//       toast.classList.remove('is-visible');
//     }, TOAST_DURATION);
//   }

//   function updateCount() {
//     const count = WishlistStore.count();
//     document.querySelectorAll('[data-wishlist-count]').forEach(el => {
//       el.textContent = count;
//       el.classList.toggle('is-visible', count > 0);
//     });
    
//     document.querySelectorAll('[data-wishlist-count-text]').forEach(el => {
//       el.textContent = `${count} ${count === 1 ? 'item' : 'items'}`;
//     });

//     const drawer = document.querySelector('[data-wishlist-drawer]');
//     if (drawer) {
//       drawer.classList.toggle('has-items', count > 0);
//     }
//   }

//   function updateButtonStates() {
//     const items = WishlistStore.get();
//     document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
//       const productId = btn.dataset.productId;
//       const isInWishlist = items.some(item => String(item.id) === String(productId));
//       btn.classList.toggle('is-active', isInWishlist);
//       btn.setAttribute('aria-label', isInWishlist ? 'Remove from wishlist' : 'Add to wishlist');
//     });
//   }

//   // ============ DRAWER CONTROL ============
//   function openDrawer() {
//     const drawer = document.querySelector('[data-wishlist-drawer]');
//     const overlay = document.querySelector('[data-wishlist-overlay]');
//     if (!drawer) return;
    
//     drawer.classList.add('is-open');
//     drawer.setAttribute('aria-hidden', 'false');
//     if (overlay) overlay.classList.add('is-open');
//     document.body.style.overflow = 'hidden';
    
//     renderItems();
//   }

//   function closeDrawer() {
//     const drawer = document.querySelector('[data-wishlist-drawer]');
//     const overlay = document.querySelector('[data-wishlist-overlay]');
//     if (!drawer) return;
    
//     drawer.classList.remove('is-open');
//     drawer.setAttribute('aria-hidden', 'true');
//     if (overlay) overlay.classList.remove('is-open');
//     document.body.style.overflow = '';
//   }

//   // ============ RENDER ITEMS ============
//   function renderItems() {
//     const container = document.querySelector('[data-wishlist-items]');
//     if (!container) return;
    
//     const items = WishlistStore.get();
    
//     if (items.length === 0) {
//       container.innerHTML = '';
//       return;
//     }

//     container.innerHTML = items.map(item => `
//       <li class="wishlist-item" data-item-id="${item.id}" data-item-handle="${item.handle}">
//         <a href="${item.url}" class="wishlist-item__image">
//           <img src="${item.image}" alt="${escapeHtml(item.title)}" loading="lazy">
//         </a>
//         <div class="wishlist-item__details">
//           <div>
//             ${item.vendor ? `<div class="wishlist-item__vendor">${escapeHtml(item.vendor)}</div>` : ''}
//             <a href="${item.url}" class="wishlist-item__title">${escapeHtml(item.title)}</a>
//           </div>
//           <div class="wishlist-item__price">${item.price}</div>
//         </div>
//         <div class="wishlist-item__actions">
//           <button type="button" class="wishlist-item__remove" data-remove-item="${item.id}" aria-label="Remove">
//             <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
//               <line x1="18" y1="6" x2="6" y2="18"/>
//               <line x1="6" y1="6" x2="18" y2="18"/>
//             </svg>
//           </button>
//           <button type="button" class="wishlist-item__add-cart" data-add-to-cart="${item.handle}">
//             Add to Cart
//           </button>
//         </div>
//       </li>
//     `).join('');
//   }

//   function escapeHtml(text) {
//     const div = document.createElement('div');
//     div.textContent = text;
//     return div.innerHTML;
//   }

//   // ============ SHOPIFY CART INTEGRATION ============
//   async function addToCart(handle, button) {
//     if (!button) return;
    
//     const originalText = button.textContent;
//     button.disabled = true;
//     button.textContent = 'Adding...';

//     try {
//       // Pehle product fetch karte hain variant ID lene ke liye
//       const productResponse = await fetch(`/products/${handle}.js`);
//       if (!productResponse.ok) throw new Error('Product not found');
      
//       const product = await productResponse.json();
//       const variantId = product.variants[0].id;

//       // Cart mein add karte hain
//       const cartResponse = await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Accept': 'application/json'
//         },
//         body: JSON.stringify({
//           items: [{ id: variantId, quantity: 1 }]
//         })
//       });

//       if (!cartResponse.ok) throw new Error('Failed to add to cart');

//       button.textContent = 'Added ✓';
//       showToast('Added to cart, removed from wishlist');
      
//       // Cart updated event
//       document.dispatchEvent(new CustomEvent('cart:updated'));
      
//       // Cart count update for native Shopify themes
//       const cartCountResponse = await fetch('/cart.js');
//       if (cartCountResponse.ok) {
//         const cart = await cartCountResponse.json();
//         document.querySelectorAll('[data-cart-count], .cart-count').forEach(el => {
//           el.textContent = cart.item_count;
//         });
//       }

//       // ✅ NEW: Item ko wishlist se remove karein - smooth animation ke saath
//       const itemEl = button.closest('.wishlist-item');
//       if (itemEl) {
//         itemEl.classList.add('is-removing');
//         setTimeout(() => {
//           WishlistStore.removeByHandle(handle);
//         }, 300);
//       } else {
//         // Fallback if element not found
//         WishlistStore.removeByHandle(handle);
//       }

//     } catch (error) {
//       console.error('Cart error:', error);
//       button.textContent = originalText;
//       button.disabled = false;
//       showToast('Failed to add. Try again.', true);
//     }
//   }

//   async function addAllToCart() {
//     const items = WishlistStore.get();
//     if (items.length === 0) return;

//     const button = document.querySelector('[data-wishlist-add-all]');
//     if (!button) return;
    
//     const originalText = button.textContent;
//     button.disabled = true;
//     button.textContent = 'Adding all...';

//     try {
//       // Saare products ke variant IDs fetch karte hain
//       const variantPromises = items.map(item =>
//         fetch(`/products/${item.handle}.js`)
//           .then(r => r.json())
//           .then(p => ({ id: p.variants[0].id, quantity: 1, handle: item.handle }))
//           .catch(() => null)
//       );
      
//       const variants = (await Promise.all(variantPromises)).filter(Boolean);

//       if (variants.length === 0) throw new Error('No variants found');

//       const response = await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ 
//           items: variants.map(v => ({ id: v.id, quantity: v.quantity }))
//         })
//       });

//       if (!response.ok) throw new Error('Failed');

//       showToast(`${variants.length} items added to cart, wishlist cleared`);
//       document.dispatchEvent(new CustomEvent('cart:updated'));

//       // ✅ NEW: Saare added items ko wishlist se remove karein
//       // Animation ke liye thoda delay
//       const drawerItems = document.querySelectorAll('.wishlist-item');
//       drawerItems.forEach(el => el.classList.add('is-removing'));
      
//       setTimeout(() => {
//         // Successfully added items ko wishlist se remove
//         variants.forEach(v => {
//           WishlistStore.removeByHandle(v.handle);
//         });
        
//         button.textContent = originalText;
//         button.disabled = false;
//       }, 400);

//     } catch (error) {
//       console.error(error);
//       button.textContent = originalText;
//       button.disabled = false;
//       showToast('Failed to add items', true);
//     }
//   }

//   // ============ EVENT HANDLERS ============
//   function handleClick(e) {
//     // Toggle wishlist button (product page)
//     const toggleBtn = e.target.closest('[data-wishlist-toggle]');
//     if (toggleBtn) {
//       e.preventDefault();
//       const productId = toggleBtn.dataset.productId;
      
//       if (WishlistStore.has(productId)) {
//         WishlistStore.remove(productId);
//         showToast('Removed from wishlist');
//       } else {
//         const product = {
//           id: productId,
//           handle: toggleBtn.dataset.productHandle,
//           title: toggleBtn.dataset.productTitle,
//           price: toggleBtn.dataset.productPrice,
//           image: toggleBtn.dataset.productImage,
//           url: toggleBtn.dataset.productUrl,
//           vendor: toggleBtn.dataset.productVendor
//         };
//         WishlistStore.add(product);
//         showToast('Added to wishlist!');
        
//         toggleBtn.classList.add('is-active');
//       }
//       return;
//     }

//     // Open drawer
//     if (e.target.closest('[data-wishlist-open]')) {
//       e.preventDefault();
//       openDrawer();
//       return;
//     }

//     // Close drawer
//     if (e.target.closest('[data-wishlist-close]') || e.target.matches('[data-wishlist-overlay]')) {
//       e.preventDefault();
//       closeDrawer();
//       return;
//     }

//     // Remove item (manual remove button)
//     const removeBtn = e.target.closest('[data-remove-item]');
//     if (removeBtn) {
//       const itemId = removeBtn.dataset.removeItem;
//       const itemEl = removeBtn.closest('.wishlist-item');
      
//       if (itemEl) {
//         itemEl.classList.add('is-removing');
//         setTimeout(() => {
//           WishlistStore.remove(itemId);
//           showToast('Item removed');
//         }, 300);
//       }
//       return;
//     }

//     // Add single item to cart (auto-removes from wishlist)
//     const addCartBtn = e.target.closest('[data-add-to-cart]');
//     if (addCartBtn) {
//       const handle = addCartBtn.dataset.addToCart;
//       addToCart(handle, addCartBtn);
//       return;
//     }

//     // Clear all
//     if (e.target.closest('[data-wishlist-clear]')) {
//       if (confirm('Clear entire wishlist?')) {
//         WishlistStore.clear();
//         showToast('Wishlist cleared');
//       }
//       return;
//     }

//     // Add all to cart (auto-clears wishlist)
//     if (e.target.closest('[data-wishlist-add-all]')) {
//       addAllToCart();
//       return;
//     }
//   }

//   // Keyboard support
//   function handleKeydown(e) {
//     if (e.key === 'Escape') {
//       const drawer = document.querySelector('[data-wishlist-drawer]');
//       if (drawer && drawer.classList.contains('is-open')) {
//         closeDrawer();
//       }
//     }
//   }

//   // ============ INIT ============
//   function init() {
//     document.addEventListener('click', handleClick);
//     document.addEventListener('keydown', handleKeydown);
    
//     document.addEventListener('wishlist:updated', () => {
//       updateCount();
//       updateButtonStates();
//       renderItems();
//     });

//     updateCount();
//     updateButtonStates();
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }

//   // Public API
//   window.ShopifyWishlist = {
//     add: (product) => WishlistStore.add(product),
//     remove: (id) => WishlistStore.remove(id),
//     removeByHandle: (handle) => WishlistStore.removeByHandle(handle),
//     get: () => WishlistStore.get(),
//     count: () => WishlistStore.count(),
//     open: openDrawer,
//     close: closeDrawer,
//     clear: () => WishlistStore.clear()
//   };
// })();
/* ===========================
   WISHLIST FUNCTIONALITY
   Shopify Custom Wishlist - With Global Exposure
   =========================== */

(function() {
  'use strict';

  const STORAGE_KEY = 'shopify_wishlist';
  const TOAST_DURATION = 2500;

  // ============ STATE MANAGEMENT ============
  const WishlistStore = {
    get() {
      try {
        const data = localStorage.getItem(STORAGE_KEY);
        return data ? JSON.parse(data) : [];
      } catch (e) {
        return [];
      }
    },
    set(items) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
        this.dispatchUpdate();
      } catch (e) {
        console.error('Wishlist save error:', e);
      }
    },
    add(product) {
      const items = this.get();
      if (!items.find(item => String(item.id) === String(product.id))) {
        items.push({ ...product, addedAt: Date.now() });
        this.set(items);
        return true;
      }
      return false;
    },
    remove(productId) {
      const items = this.get().filter(item => String(item.id) !== String(productId));
      this.set(items);
    },
    removeByHandle(handle) {
      const items = this.get().filter(item => item.handle !== handle);
      this.set(items);
    },
    clear() {
      this.set([]);
    },
    has(productId) {
      return this.get().some(item => String(item.id) === String(productId));
    },
    count() {
      return this.get().length;
    },
    dispatchUpdate() {
      document.dispatchEvent(new CustomEvent('wishlist:updated', {
        detail: { items: this.get(), count: this.count() }
      }));
    }
  };

  // ============ GLOBAL EXPOSURE (fixes inline script errors) ============
  window.WishlistStore = WishlistStore;

  // ============ UI HELPERS ============
  function showToast(message, isError) {
    const toast = document.querySelector('[data-wishlist-toast]');
    if (!toast) return;
    const textEl = toast.querySelector('[data-wishlist-toast-text]');
    if (textEl) textEl.textContent = message;
    toast.classList.toggle('is-error', !!isError);
    toast.classList.add('is-visible');
    clearTimeout(toast._timeout);
    toast._timeout = setTimeout(() => toast.classList.remove('is-visible'), TOAST_DURATION);
  }

  function updateCount() {
    const count = WishlistStore.count();
    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      el.textContent = count;
      el.classList.toggle('is-visible', count > 0);
    });
    document.querySelectorAll('[data-wishlist-count-text]').forEach(el => {
      el.textContent = count + ' ' + (count === 1 ? 'item' : 'items');
    });
    const drawer = document.querySelector('[data-wishlist-drawer]');
    if (drawer) drawer.classList.toggle('has-items', count > 0);
  }

  function updateButtonStates() {
    const items = WishlistStore.get();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
      const productId = btn.dataset.productId;
      const isInWishlist = items.some(item => String(item.id) === String(productId));
      btn.classList.toggle('is-active', isInWishlist);
      btn.setAttribute('aria-label', isInWishlist ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }

  window.showWishlistToast = showToast;

  // ============ DRAWER CONTROL ============
  function openDrawer() {
    const drawer = document.querySelector('[data-wishlist-drawer]');
    const overlay = document.querySelector('[data-wishlist-overlay]');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    renderItems();
  }

  function closeDrawer() {
    const drawer = document.querySelector('[data-wishlist-drawer]');
    const overlay = document.querySelector('[data-wishlist-overlay]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  // ============ RENDER ITEMS ============
  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text || '';
    return div.innerHTML;
  }

  function renderItems() {
    const container = document.querySelector('[data-wishlist-items]');
    if (!container) return;
    const items = WishlistStore.get();
    if (items.length === 0) {
      container.innerHTML = '';
      return;
    }
    container.innerHTML = items.map(item => `
      <li class="wishlist-item" data-item-id="${item.id}" data-item-handle="${item.handle}">
        <a href="${item.url}" class="wishlist-item__image">
          <img src="${item.image}" alt="${escapeHtml(item.title)}" loading="lazy">
        </a>
        <div class="wishlist-item__details">
          <div>
            ${item.vendor ? `<div class="wishlist-item__vendor">${escapeHtml(item.vendor)}</div>` : ''}
            <a href="${item.url}" class="wishlist-item__title">${escapeHtml(item.title)}</a>
          </div>
          <div class="wishlist-item__price">${item.price}</div>
        </div>
        <div class="wishlist-item__actions">
          <button type="button" class="wishlist-item__remove" data-remove-item="${item.id}" aria-label="Remove">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
          <button type="button" class="wishlist-item__add-cart" data-add-to-cart="${item.handle}">
            Add to Cart
          </button>
        </div>
      </li>
    `).join('');
  }

  // ============ CART INTEGRATION ============
  async function addToCart(handle, button) {
    if (!button) return;
    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...';
    try {
      const productResponse = await fetch('/products/' + handle + '.js');
      if (!productResponse.ok) throw new Error('Product not found');
      const product = await productResponse.json();
      const variantId = product.variants[0].id;
      const cartResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      if (!cartResponse.ok) throw new Error('Failed to add to cart');
      button.textContent = 'Added';
      showToast('Added to cart, removed from wishlist');
      document.dispatchEvent(new CustomEvent('cart:updated'));
      const cartCountResponse = await fetch('/cart.js');
      if (cartCountResponse.ok) {
        const cart = await cartCountResponse.json();
        document.querySelectorAll('[data-cart-count], .cart-count').forEach(el => {
          el.textContent = cart.item_count;
        });
      }
      const itemEl = button.closest('.wishlist-item');
      if (itemEl) {
        itemEl.classList.add('is-removing');
        setTimeout(() => WishlistStore.removeByHandle(handle), 300);
      } else {
        WishlistStore.removeByHandle(handle);
      }
    } catch (error) {
      console.error('Cart error:', error);
      button.textContent = originalText;
      button.disabled = false;
      showToast('Failed to add. Try again.', true);
    }
  }

  async function addAllToCart() {
    const items = WishlistStore.get();
    if (items.length === 0) return;
    const button = document.querySelector('[data-wishlist-add-all]');
    if (!button) return;
    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding all...';
    try {
      const variantPromises = items.map(item =>
        fetch('/products/' + item.handle + '.js')
          .then(r => r.json())
          .then(p => ({ id: p.variants[0].id, quantity: 1, handle: item.handle }))
          .catch(() => null)
      );
      const variants = (await Promise.all(variantPromises)).filter(Boolean);
      if (variants.length === 0) throw new Error('No variants found');
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: variants.map(v => ({ id: v.id, quantity: v.quantity })) })
      });
      if (!response.ok) throw new Error('Failed');
      showToast(variants.length + ' items added to cart, wishlist cleared');
      document.dispatchEvent(new CustomEvent('cart:updated'));
      const drawerItems = document.querySelectorAll('.wishlist-item');
      drawerItems.forEach(el => el.classList.add('is-removing'));
      setTimeout(() => {
        variants.forEach(v => WishlistStore.removeByHandle(v.handle));
        button.textContent = originalText;
        button.disabled = false;
      }, 400);
    } catch (error) {
      button.textContent = originalText;
      button.disabled = false;
      showToast('Failed to add items', true);
    }
  }

  // ============ TOGGLE LOGIC ============
  function toggleWishlist(btn) {
    const productId = btn.dataset.productId;
    if (WishlistStore.has(productId)) {
      WishlistStore.remove(productId);
      showToast('Removed from wishlist');
    } else {
      WishlistStore.add({
        id: productId,
        handle: btn.dataset.productHandle,
        title: btn.dataset.productTitle,
        price: btn.dataset.productPrice,
        image: btn.dataset.productImage,
        url: btn.dataset.productUrl,
        vendor: btn.dataset.productVendor
      });
      showToast('Added to wishlist!');
    }
  }

  window.toggleWishlist = toggleWishlist;

  // ============ DRAWER EVENT HANDLERS ============
  function handleClick(e) {
    if (e.target.closest('[data-wishlist-open]')) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-wishlist-close]') || e.target.matches('[data-wishlist-overlay]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }
    const removeBtn = e.target.closest('[data-remove-item]');
    if (removeBtn) {
      const itemId = removeBtn.dataset.removeItem;
      const itemEl = removeBtn.closest('.wishlist-item');
      if (itemEl) {
        itemEl.classList.add('is-removing');
        setTimeout(() => {
          WishlistStore.remove(itemId);
          showToast('Item removed');
        }, 300);
      }
      return;
    }
    const addCartBtn = e.target.closest('[data-add-to-cart]');
    if (addCartBtn) {
      addToCart(addCartBtn.dataset.addToCart, addCartBtn);
      return;
    }
    if (e.target.closest('[data-wishlist-clear]')) {
      if (confirm('Clear entire wishlist?')) {
        WishlistStore.clear();
        showToast('Wishlist cleared');
      }
      return;
    }
    if (e.target.closest('[data-wishlist-add-all]')) {
      addAllToCart();
      return;
    }
  }

  function handleKeydown(e) {
    if (e.key === 'Escape') {
      const drawer = document.querySelector('[data-wishlist-drawer]');
      if (drawer && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    }
  }

  // ============ BULLETPROOF CARD BUTTON LISTENERS ============
  function attachCardListeners() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function(btn) {
      if (btn._wishlistBound) return;
      btn._wishlistBound = true;
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        toggleWishlist(btn);
        return false;
      }, true);
    });
  }

  // ============ INIT ============
  function init() {
    document.addEventListener('click', handleClick);
    document.addEventListener('keydown', handleKeydown);
    document.addEventListener('wishlist:updated', () => {
      updateCount();
      updateButtonStates();
      renderItems();
    });
    attachCardListeners();
    new MutationObserver(attachCardListeners).observe(document.body, {
      childList: true,
      subtree: true
    });
    updateCount();
    updateButtonStates();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ============ PUBLIC API ============
  window.ShopifyWishlist = {
    add: (product) => WishlistStore.add(product),
    remove: (id) => WishlistStore.remove(id),
    removeByHandle: (handle) => WishlistStore.removeByHandle(handle),
    get: () => WishlistStore.get(),
    count: () => WishlistStore.count(),
    open: openDrawer,
    close: closeDrawer,
    clear: () => WishlistStore.clear()
  };
})();